module.exports = __webpack_public_path__ + "static/img/private-community.809f59f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/how-it-works/private-community.png
// module id = 2Gv5
// module chunks = 35